module.exports = __webpack_public_path__ + "img/media-27.6612a0c0.png";